import { Helmet } from "react-helmet-async"
import { Container } from "@sembark-travel/ui-base"
import { TripVoucherTemplates } from "../../../../../EmailPdfTemplates"

export default function OrganizationTripVoucherTemplatesPage() {
	return (
		<>
			<Helmet>
				<title>Trip Voucher</title>
			</Helmet>
			<Container paddingY="4">
				<TripVoucherTemplates />
			</Container>
		</>
	)
}
